export default class Queuer {
  constructor(options) {
    this.group = options.group || 1;

    this.total = options.data.length;
    this.waiting = options.data || [];
    this.current = [];

    this.timeout = options.timeout || null;

    this.task = options.task;
    this.done = options.done;
    this.isStopped = false;
    this.timeoutId = null;  // Ajout d'une variable pour stocker l'ID du timeout
  }

  /**
   * Initialize the Queuer
   */
  init() {
    if (this.isStopped) return;

    if (this.pack() <= 0) {
      if (this.done) this.done();
      return;
    }

    for (let i = 0; i < this.current.length; i++) {
      this.task.bind(this)(this.current[i]);
    }
  }

  /**
   * Unlock the next pack in the Queue
   */
  unlock() {
    if (this.isStopped) return;

    this.current.splice(0, 1);

    if (this.current.length > 0) return;

    if (this.timeout) {
      this.timeoutId = setTimeout(() => this.init(), this.timeout);
    } else {
      this.init();
    }
  }

  /**
   * Pack the next group in the queue
   */
  pack() {
    if (this.isStopped) return 0;

    this.current = this.waiting.splice(0, this.group);
    return this.current.length;
  }

  /**
   * Stop the Queuer
   */
  stop() {
    this.isStopped = true;
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);  // Annuler le timeout si nécessaire
    }
  }
}
